<script>
  import { onMount } from 'svelte'
  import PageHeader from '/components/Atoms/PageHeader'
  import MarkdownRenderer from '/components/Groups/MarkdownRenderer'
  import SideGroup from '/components/Groups/SideGroup'
  import Related from '/Groups/Related'

  export let data, title

  let page = data?.Text || data?.Project || {}
  let blocks = data?.Text?.body || data?.Project?.body || []

  const sideWidgets = page?.relatedWidgets || []

  onMount(()=>{
    const hash = window.location.hash
    if (hash) {
      const elem = document.querySelector(hash)
      if (elem) {
        window.scroll({
          top: elem.getBoundingClientRect().top - 100, 
          left: 0, 
          behavior: 'smooth'
        });
      }
    }
  })

</script>

<div class="container">

  {#if title}
    <div class="header">
      <PageHeader>
        {title}
      </PageHeader>
    </div>
  {/if}

  <section class="main">
    {#if blocks}
      <MarkdownRenderer {blocks} />
    {/if}

    <Related data={page} />

  </section>

  <aside class="side">
    <SideGroup widgets={sideWidgets} />
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
    

  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  :global(.single-page-logos) {
    padding: 2em 0;

    @include media-large-only {
      width: 100%;
      display: grid;
      flex-direction: row;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 6%;
      grid-auto-rows: 120px;

      :global(a), :global(img) {
          width: 100%;
          height: 100%;
        }
      :global(img) {
        object-fit: contain;
      }
    }

    @include media-small {
      :global( > * ) {
        max-width: 250px;
        display: block;
        margin-bottom: 1em;
      }
    }

  }    

  :global(.single-page-press-images) {
    padding: 2em 0;

    width: 100%;
    display: grid;
    flex-direction: row;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1em;

    :global(.single-page-press-images-item) {
      margin-bottom: 1em;
      @include typo-grotesk-title-captions-20;
    }

  }    


</style>
